import React from 'react';
import $ from '../../../../offline/jquery.min.js';
import classNames from "classnames";
import {
  Chat,
  Channel,
  MessageList,
  MessageInput,
  MessageTeam,
  Window
} from 'stream-chat-react';

import {
  ChatContainer,
  WrapperChatHeader,
  ContainerMessage,
  ContainerChatHeader,
  ChatMemberListHeader,
  MemberListContainer,
  WrapperContainerMessageList,
  WrapperContainerMessage,
  WrapperListOptions,
  OptionList
} from './components';

import { ChatStreamContext } from '../../../Context/ChatStreamContext';

import ConfigService from "../../../Services/api/Config";
import History from "../../../Services/History";

import ModalDeleteChat from "../ModalDeleteChat";
import ModalExitChat from "../ModalExitChat";
import ModalAddPeopleChat from "../ModalAddPeopleChat";
import ModalDeletePeopleChat from "../ModalDeletePeopleChat";
import Icon from "../../Common/Icon";
import ChatMemberList from "../ChatMemberList";
import MessageCustomDeleted from "./messageDeleted";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";
import {ReactComponent as ExpandIcon} from "../../../../img/arrows-expand.svg";
import {ReactComponent as CompressIcon} from "../../../../img/arrows-compress.svg";
import {ReactComponent as OptionIcon} from "../../../../img/task-teaser-actions-expand.svg";
import {ReactComponent as ArrowIcon} from "../../../../img/icon-triangle-dialog-1.svg";
import {ReactComponent as CircleIcon} from "../../../../img/icon-circle.svg";
import {ReactComponent as MuteIcon} from "../../../../img/icon-sound-off.svg";
import IconBlue from "../../Common/Icon/blue";

class ChatSection extends React.Component {
  static contextType = ChatStreamContext;

  constructor(props) {
    super(props);

    this.state = {
      memberList: [],
      showOptions: false,
      modalDelete: false,
      modalExit: false,
      modalAddPeople: false,
      modalDeletePeople: false,
      scrollElement: null,
      scrollAuto: false,
    };
    this.chatMessageList = React.createRef();
  }

  componentDidMount() {
    const { channel } = this.props;
    setTimeout(() => {
      if (this.chatMessageList && this.chatMessageList.current) {
        const elementScroll = $(this.chatMessageList.current).find('.str-chat__reverse-infinite-scroll');
        if (elementScroll.length > 0) {
          elementScroll[0].addEventListener('scroll', this.getScrollMessages);
          this.setState({
            scrollElement: elementScroll
          });
        }
      }
    }, 500);
    History.singleton().register('modalDeletePeople', () => {
     this.onPressedDeletePeople();
    }, () => {
     this.onPressedModalDeletePeopleClose();
    });
    History.singleton().register('modalAddPeople', () => {
     this.onPressedAddPeople();
    }, () => {
     this.onPressedModalAddPeopleClose();
    });
    History.singleton().register('modalExit', () => {
     this.onPressedExit();
    }, () => {
     this.onPressedModalExitClose();
    });
    History.singleton().register('modalDelete', () => {
     this.onPressedDelete();
    }, () => {
     this.onPressedModalDeleteClose();
    });
    channel.on('message.new', this.eventMessageNew);
    channel.on('message.updated', this.eventMessageUpdated);
    channel.on('message.deleted', this.eventMessageUpdated);
    channel.on('reaction.new', this.eventMessageUpdated);
    channel.on('reaction.deleted', this.eventMessageUpdated);
    channel.on('channel.deleted', this.eventChannelDelete);
    channel.on('channel.updated', this.eventChannelChanged);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { channel } = this.props;
    const { scrollAuto } = this.state;
    if (channel.messageLink && !scrollAuto) {
      setTimeout(() => {
        this.scrollTop();
      }, 500);
    }
  }

  componentWillUnmount() {
    const { scrollElement } = this.state;
    const { channel } = this.props;
    if (scrollElement) {
      scrollElement[0].removeEventListener('scroll', this.getScrollMessages);
    }
    History.singleton().unregister('modalDeletePeople');
    History.singleton().unregister('modalAddPeople');
    History.singleton().unregister('modalExit');
    History.singleton().unregister('modalDelete');
    channel.off('message.new', this.eventMessageNew);
    channel.off('message.updated', this.eventMessageUpdated);
    channel.off('message.deleted', this.eventMessageUpdated);
    channel.off('reaction.new', this.eventMessageUpdated);
    channel.off('reaction.deleted', this.eventMessageUpdated);
    channel.off('channel.deleted', this.eventChannelDelete);
    channel.off('channel.updated', this.eventChannelChanged);
  }

  eventMessageNew = async (event) => {
    const { updateChannelList } = this.context;
    await updateChannelList(event.channel_id);
    setTimeout(this.scrollBottom, 0);
  }

  eventMessageUpdated = async (event) => {
    const { updateChannelList } = this.context;
    await updateChannelList(event.channel_id);
  }

  eventChannelChanged = async (event) => {
    const { updateChannelList } = this.context;
    const { channel } = this.props;
    if (channel.id === event.channel_id) {
      await updateChannelList(event.channel_id);
    }
  }

  eventChannelDelete = async (event) => {
    const { channel } = this.props;
    if (channel.id === event.channel_id) {
      this.removeChannel();
    }
  }

  onPressedDeletePeople = () => {
    History.singleton().show('modalDeletePeople');
    this.toggleExpandOptions();
    this.removeMemberList();
    this.setState({ modalDeletePeople: true });
  };

  onPressedModalDeletePeopleClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalDeletePeople: false });
  };

  onPressedAddPeople = () => {
    History.singleton().show('modalAddPeople');
    this.toggleExpandOptions();
    this.removeMemberList();
    this.setState({ modalAddPeople: true });
  };

  onPressedModalAddPeopleClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalAddPeople: false });
  };

  onPressedExit = () => {
    History.singleton().show('modalExit');
    this.toggleExpandOptions();
    this.removeMemberList();
    this.setState({ modalExit: true });
  };

  onPressedModalExitClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalExit: false });
  };

  onPressedDelete = () => {
    History.singleton().show('modalDelete');
    this.toggleExpandOptions();
    this.removeMemberList();
    this.setState({ modalDelete: true });
  };

  onPressedModalDeleteClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalDelete: false });
  };

  showChat = () => {
    const { channelsActive, channel } = this.props;
    let show = false;
    if (channelsActive) {
      channelsActive.map((chat) => {
        if (chat.id === channel.id) {
          show = true;
        }
      });
    }
    return show;
  };

  chatExpand = () => {
    const { channelsExpand, channel } = this.props;
    let expand = false;
    if (channelsExpand) {
      channelsExpand.map((chat) => {
        if (chat.id === channel.id) {
          expand = true;
        }
      });
    }
    return expand;
  };

  removeChannel = () => {
    const { onRemoveSelectChat } = this.context;
    const { channel } = this.props;
    onRemoveSelectChat(channel);
  };

  deleteChannel = () => {
    const { deleteDirectChat } = this.context;
    const { channel } = this.props;
    deleteDirectChat(channel);
  };

  exitChannel = () => {
    const { exitDirectChat } = this.context;
    const { channel } = this.props;
    exitDirectChat(channel);
  };

  deletePeopleChannel = (users) => {
    const { removeMembersChat } = this.context;
    const { channel } = this.props;
    removeMembersChat(channel, users);
  };

  addPeopleChannel = async (users) => {
    const { createDirectChat, onSelectChat, getChatChannelData, currentUser } = this.context;
    const { channel } = this.props;
    channel.dataChat.memberList.map(({ user }) => {
      if (user.id !== currentUser.id) {
        users.push(user);
      }
    });
    const chat = await createDirectChat(users);
    if (chat) {
      chat.dataChat = getChatChannelData(chat);
      onSelectChat(chat);
    }
  };

  toggleChannel = () => {
    if (this.showChat()) {
      this.closeChannel();
    }
    else {
      this.openChannel();
    }
  };

  toggleExpandChannel = () => {
    if (this.chatExpand()) {
      this.compressChannel();
    }
    else {
      this.expandChannel();
    }
  };

  toggleExpandOptions = () => {
    const { showOptions } = this.state;
    this.setState({
      showOptions: !showOptions
    });
  };

  openChannel = () => {
    const { onSelectChatActive } = this.context;
    const { channel } = this.props;
    onSelectChatActive(channel);
  };

  expandChannel = () => {
    const { onSelectChatExpand } = this.context;
    const { channel } = this.props;
    onSelectChatExpand(channel);
  };

  closeChannel = () => {
    const { onRemoveChatActive } = this.context;
    const { channel } = this.props;
    this.removeMemberList();
    onRemoveChatActive(channel);
  };

  compressChannel = () => {
    const { onRemoveChatExpand } = this.context;
    const { channel } = this.props;
    onRemoveChatExpand(channel);
  };

  unMuteChannel = async (channel) => {
    const { updateChannelList } = this.context;
    await channel.unmute();
    updateChannelList(channel.id);
    this.toggleExpandOptions();
  }

  muteChannel = async (channel) => {
    const { updateChannelList } = this.context;
    await channel.mute();
    updateChannelList(channel.id);
    this.toggleExpandOptions();
  }

  showMemberList = () => {
    const { channel } = this.props;
    const showChat = Boolean(this.showChat(channel));
    if (showChat) {
      this.setState({
        memberList: channel.dataChat.memberList
      });
    }
  };

  removeMemberList = () => {
    this.setState({
      memberList: []
    });
  };

  getScrollMessages = async (event) => {
    const { getPrevMessages, getNextMessages } = this.context;
    const { scrollElement, scrollAuto } = this.state;
    const { channel } = this.props;
    if (scrollAuto) {
      return;
    }
    const scrollTop = (-1 * scrollElement.scrollTop());
    const scrollLimitTop = scrollElement.find('.str-chat__ul').height() - scrollElement.height() - 3;
    if (scrollTop > scrollLimitTop) {
      await getPrevMessages(channel);
    }
    else if (scrollTop <= 0) {
      await getNextMessages(channel);
    }
    event.preventDefault();
    event.stopPropagation();
  };

  scrollTop = () => {
    const { scrollElement, scrollAuto } = this.state;
    const { channel } = this.props;
    const { removeLinkChannel } = this.context;
    if (scrollElement && !scrollAuto) {
      this.setState({scrollAuto:true});
      const scrollTop = 20 - scrollElement.find('.str-chat__ul').height();
      scrollElement.animate({scrollTop: scrollTop}, 'fast');
      setTimeout(() => {
        this.setState({
          scrollAuto:false,
        });
        removeLinkChannel(channel);
      }, 500);
    }
  }

  scrollBottom = () => {
    const { scrollElement, scrollAuto } = this.state;
    if (scrollElement && !scrollAuto) {
      this.setState({scrollAuto:true});
      const scrollBottom = scrollElement.find('.str-chat__ul').height();
      scrollElement.animate({scrollTop: scrollBottom}, 'fast');
      setTimeout(() => {
        this.setState({
          scrollAuto:false,
        });
      }, 500);
    }
  }

  getColorIconChannel = (channel) => {
    const { currentUser } = this.props;
    let online = false;
    Object.keys(channel.state.members).forEach((key) => {
      const user = channel.state.members[key] ? channel.state.members[key].user : {};
      if (currentUser && (currentUser.id !== user.id) && user.online) {
        online = true;
      }
    });
    return online ? 'successColor' : 'errorColor';
  };

  renderMemberList = () => {
    const { memberList } = this.state;

    return (
      <MemberListContainer
        borderColor={ ConfigService.getColor('tertiaryColor', 0.3) }
        className={ classNames({
          Closed: memberList.length === 0
        })}
      >
        <ChatMemberListHeader textColor={ ConfigService.getColor('primaryColor') }>
          <span>
            Members
          </span>
          <Icon width='12' height='12' color='primaryColor' onClick={this.removeMemberList}>
            <CloseIcon alt='icon-close'/>
          </Icon>
        </ChatMemberListHeader>
        <ChatMemberList
          members={ memberList }
        />
      </MemberListContainer>
    )
  };

  renderCustomHeaderChat = () => {
    const { channel } = this.props;
    const { getChannelType } = this.context;
    let watcherCount = 0;
    if (channel && channel.state) {
      Object.keys(channel.state.members).forEach((key) => {
        if (channel.state.members[key].user.online) {
          watcherCount++;
        }
      });
    }

    const memberCount = (channel && channel.data) ? channel.data.member_count : 0;
    const messagesUnread = (channel && channel.dataChat) ? channel.dataChat.messagesUnread : 0;

    return (
      <div className="str-chat__header-livestream">
        { (getChannelType(channel) === 'direct') &&
          <Icon width='10' height='10' color={ this.getColorIconChannel(channel) }>
              <CircleIcon alt='icon-circle'/>
          </Icon>
        }
        <div className="str-chat__header-livestream-left">
          <div className="str-chat__header-livestream-left-content">
            <div className="str-chat__header-livestream-left--title pointer" onClick={this.toggleChannel}>
              <p>{ channel.dataChat.viewChatName }</p>
              { messagesUnread > 0 &&
                <IconBlue>{messagesUnread}</IconBlue>
              }
            </div>
            { (getChannelType(channel) !== 'direct') &&
              <p className="str-chat__header-livestream-left--members left pointer" onClick={this.showMemberList}>
                {memberCount > 0 &&
                <>
                  {memberCount} members,{' '}
                </>
                }
                {watcherCount} online
              </p>
            }
          </div>
          { channel.muteStatus().muted &&
            <Icon className='IconMute' width='15' height='15' color='white'>
              <MuteIcon alt='icon-mute'/>
            </Icon>
          }
        </div>
      </div>
    )
  };

  customMessage = (props) => {
    const { chatClient } = this.context;
    const { channel } = this.props;
    const { message } = props;
    const otherMessageAction = message.user.id !==  chatClient.user.id ? [] : ['edit', 'delete']
    const messageActions = [...otherMessageAction];
    if (channel.messageLink && channel.messageLink.id === message.id) {
      message.type = 'bold';
    }
    return <MessageTeam {...props} getMessageActions={ () => messageActions } MessageDeleted={MessageCustomDeleted}/>;
  };

  render () {
    const { chatClient, channel, currentUser, searchUserList, searchRecentList } = this.props;
    const { showOptions, modalDelete, modalExit, modalDeletePeople, modalAddPeople } = this.state;
    const { checkChannelCustom } = this.context;

    const showChat = Boolean(this.showChat(channel));
    const expandChat = Boolean(this.chatExpand(channel));
    const memberCount = channel.dataChat.memberNumber;
    let widthHeader = 22;
    if (showChat) {
      widthHeader = widthHeader + (checkChannelCustom(channel) ? 44 : 22);
    }
    const messages = channel.dataChat.messages || channel.state.messages;
    const isOwner = channel.state.membership.is_moderator;

    return (
      <ChatContainer
        className={ classNames('Chat-Element', {
            'Chat-Element-Closed': !showChat,
            'Chat-Element-Expand': expandChat,
          })}
      >
        <WrapperChatHeader
          backgroundColor={ ConfigService.getColor('primaryColor') }
        >
          <ContainerChatHeader maxWidth={widthHeader}>
            { this.renderCustomHeaderChat() }
          </ContainerChatHeader>
          <Icon
            width='12'
            height='12'
            colorChange='primaryColor'
            color='white'
            onClick={this.toggleExpandChannel}
            className={classNames({
              Hidden: !showChat
            })}
          >
            { !expandChat &&
              <ExpandIcon alt='icon-expand'/>
              ||
              <CompressIcon alt='icon-compress'/>
            }
          </Icon>
          <WrapperListOptions className={classNames({
            Hidden: !showChat
          })}>
            <Icon width='12' height='12' colorChange='primaryColor' color='white' onClick={this.toggleExpandOptions}>
              <OptionIcon alt='icon-option'/>
            </Icon>
            {showOptions &&
              <div className='Block-Dialog'>
                <Icon className='Icon-Arrow-Dialog' width='20' height='10'>
                  <ArrowIcon alt='icon-arrow-dialog'/>
                </Icon>
                <OptionList borderColor={ConfigService.getColor('tertiaryColor', 0.3)}>
                  <ul>
                    { channel.muteStatus().muted &&
                      <li onClick={() => this.unMuteChannel(channel)}>Unmute channel</li>
                      ||
                      <li onClick={() => this.muteChannel(channel)}>Mute channel</li>
                    }
                  </ul>
                </OptionList>
                { checkChannelCustom(channel) &&
                  <>
                    { isOwner &&
                      <OptionList borderColor={ConfigService.getColor('tertiaryColor', 0.3)}>
                        <ul>
                          <li onClick={this.onPressedAddPeople}>Add people</li>
                          { (memberCount > 2) &&
                            <li onClick={this.onPressedDeletePeople}>Delete people</li>
                          }
                        </ul>
                      </OptionList>
                    }
                    <OptionList>
                      <ul>
                        <li onClick={this.onPressedExit}>Exit channel</li>
                        {/*{ isOwner && (memberCount > 2) &&*/}
                        {/*  <li onClick={this.onPressedDelete}>Delete channel</li>*/}
                        {/*}*/}
                      </ul>
                    </OptionList>
                  </>
                }
              </div>
            }
          </WrapperListOptions>
          <Icon width='12' height='12' colorChange='secondaryColor' color='white' onClick={this.removeChannel}>
            <CloseIcon alt='icon-close'/>
          </Icon>
        </WrapperChatHeader>

        <WrapperContainerMessageList ref={ this.chatMessageList } className={ classNames('Chat-Element-Slide', {
              'Chat-Element-Closed': !showChat,
              'Chat-Element-Expand': expandChat,
            })}>
          {showChat &&
            <Chat client={chatClient}>
              <Channel channel={channel} theme={'messaging light'}>
                <Window>
                  <WrapperContainerMessage>
                    {this.renderMemberList()}
                    <ContainerMessage>
                      <MessageList
                        Message={ this.customMessage }
                        messages={ messages }
                      />
                      <MessageInput/>
                    </ContainerMessage>
                  </WrapperContainerMessage>
                </Window>
              </Channel>
            </Chat>
          }
        </WrapperContainerMessageList>
        { modalDelete && (
          <ModalDeleteChat
            onClose={ this.onPressedModalDeleteClose }
            onSubmit={ this.deleteChannel }
          />
        ) }
        { modalExit && (
          <ModalExitChat
            onClose={ this.onPressedModalExitClose }
            onSubmit={ this.exitChannel }
          />
        ) }
        { modalDeletePeople && (
          <ModalDeletePeopleChat
            onClose={ this.onPressedModalDeletePeopleClose }
            onSubmit={ this.deletePeopleChannel }
            memberList={ channel.dataChat.memberList }
            currentUser={ currentUser }
          />
        ) }
        { modalAddPeople && (
          <ModalAddPeopleChat
            onClose={ this.onPressedModalAddPeopleClose }
            onSubmit={ this.addPeopleChannel }
            searchUserList={ searchUserList }
            searchRecentList={ searchRecentList }
            excludeMembers={ channel.dataChat.memberList }
          />
        ) }
      </ChatContainer>
    )
  }
}

export default React.memo(ChatSection);